module.exports = __webpack_public_path__ + "img/20.e1a3038f.jpg";